import { Center as MantineCenter } from "@mantine/core";

export const Center = MantineCenter;
